import { connectedStore } from '../../store';
import setInlineElementStyleAction from '../actions/set-inline-element-style';
import { USED_ACTION_CREATOR } from '../constants/symbols';

const setInlineElementStyle = (elementId, propertyName, value, options) => {
  const store = connectedStore.get();
  store.dispatch(setInlineElementStyleAction(elementId, propertyName, value, options));
};

setInlineElementStyle[USED_ACTION_CREATOR] = setInlineElementStyleAction;

export default setInlineElementStyle;
